module.exports = "https://trybtryb-legacy.web.app/img/half-transparent-special-desktop.5de5d372.svg";